import { decodeHexResponse } from '../_common/common.utils';
import NewReportTypes from './NewReport.types';

const INITIAL_STATE = {
	attendanceReport: null,
	leaveReport: null,
	sectionWiseAttendanceReport: null,
	designationWiseLeaveReport: null,
	managementLeaveReport: null,
	employeeLeaveReport: null,
	monthlyAttendanceSummaryReport: null,
	monthlyCheckoutReport: null,
	monthlyCheckoutDetailsReport: null,
	compOffReport: null,
	refreshmentReport: null,
	onDutyReport: null,
	allEmployeesCheckInOut: null,
	checkInLockedResponse: null,
	checkInLockedHistoryResponse: null,
	checkInLockedExcuseResponse: null,
	checkInUnLockedHistoryResponse: null,
	festivalAdvanceReport: null,
	allFestivalNames: null,
	updateFestivalAdvanceStatus: null,
	medicalAllowanceReport: null,
	updateMedicalAllowanceStatus: null,
};

//ATTENDANCE REPORT REDUCER
const newReportReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		case NewReportTypes.GET_ATTENDANCE_REPORT_START:
			return { ...state, attendanceReport: null };
		case NewReportTypes.GET_ATTENDANCE_REPORT_SUCCESS:
			return {
				...state,
				attendanceReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_ATTENDANCE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_ATTENDANCE_REPORT_FAILURE:
			return {
				...state,
				attendanceReport: { status: 'error', message: action.payload },
			};

		//LEAVE REPORT REDUCER
		case NewReportTypes.GET_LEAVE_REPORT_START:
			return { ...state, leaveReport: null };
		case NewReportTypes.GET_LEAVE_REPORT_SUCCESS:
			return {
				...state,
				leaveReport: decodeHexResponse(action.payload, NewReportTypes.GET_LEAVE_REPORT_KEY),
			};
		case NewReportTypes.GET_LEAVE_REPORT_FAILURE:
			return {
				...state,
				leaveReport: { status: 'error', message: action.payload },
			};
		//SECTION WISE ATTENDANCE REPORT REDUCER
		case NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_START:
			return { ...state, sectionWiseAttendanceReport: null };
		case NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_SUCCESS:
			return {
				...state,
				sectionWiseAttendanceReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_FAILURE:
			return {
				...state,
				sectionWiseAttendanceReport: { status: 'error', message: action.payload },
			};
		// DESIGNATION WISE LEAVE REPORT REDUCER
		case NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_START:
			return { ...state, designationWiseLeaveReport: null };
		case NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_SUCCESS:
			return {
				...state,
				designationWiseLeaveReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_FAILURE:
			return {
				...state,
				designationWiseLeaveReport: { status: 'error', message: action.payload },
			};
		// EMPLOYEE LEAVE REPORT REDUCER
		case NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_START:
			return { ...state, employeeLeaveReport: null };
		case NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_SUCCESS:
			return {
				...state,
				employeeLeaveReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_FAILURE:
			return {
				...state,
				employeeLeaveReport: { status: 'error', message: action.payload },
			};
		// MANAGEMENT LEAVE REPORT REDUCER
		case NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_START:
			return { ...state, managementLeaveReport: null };
		case NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_SUCCESS:
			return {
				...state,
				managementLeaveReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_FAILURE:
			return {
				...state,
				managementLeaveReport: { status: 'error', message: action.payload },
			};
		// MONTHLY ATTENDANCE SUMMARY REPORT REDUCER
		case NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_START:
			return { ...state, monthlyAttendanceSummaryReport: null };
		case NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS:
			return {
				...state,
				monthlyAttendanceSummaryReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE:
			return {
				...state,
				monthlyAttendanceSummaryReport: { status: 'error', message: action.payload },
			};
		// MONTHLY CHECKOUT REPORT REDUCER
		case NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_START:
			return { ...state, monthlyCheckoutReport: null };
		case NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_SUCCESS:
			return {
				...state,
				monthlyCheckoutReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_FAILURE:
			return {
				...state,
				monthlyCheckoutReport: { status: 'error', message: action.payload },
			};
		// MONTHLY CHECKOUT DETAILS REDUCER
		case NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_START:
			return { ...state, monthlyCheckoutDetailsReport: null };
		case NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_SUCCESS:
			return {
				...state,
				monthlyCheckoutDetailsReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_KEY,
				),
			};
		case NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_FAILURE:
			return {
				...state,
				monthlyCheckoutDetailsReport: { status: 'error', message: action.payload },
			};
		// COMP OFF REPORT REDUCER
		case NewReportTypes.GET_COMPOFF_REPORT_START:
			return { ...state, compOffReport: null };
		case NewReportTypes.GET_COMPOFF_REPORT_SUCCESS:
			return {
				...state,
				compOffReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_COMPOFF_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_COMPOFF_REPORT_FAILURE:
			return {
				...state,
				compOffReport: { status: 'error', message: action.payload },
			};
		// REFRESHMENT REPORT REDUCER
		case NewReportTypes.GET_REFRESHMENT_REPORT_START:
			return { ...state, refreshmentReport: null };
		case NewReportTypes.GET_REFRESHMENT_REPORT_SUCCESS:
			return {
				...state,
				refreshmentReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_REFRESHMENT_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_REFRESHMENT_REPORT_FAILURE:
			return {
				...state,
				refreshmentReport: { status: 'error', message: action.payload },
			};
		// ON DUTY REPORT REDUCER
		case NewReportTypes.GET_ONDUTY_REPORT_START:
			return { ...state, onDutyReport: null };
		case NewReportTypes.GET_ONDUTY_REPORT_SUCCESS:
			return {
				...state,
				onDutyReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_ONDUTY_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_ONDUTY_REPORT_FAILURE:
			return {
				...state,
				onDutyReport: { status: 'error', message: action.payload },
			};
		// GET ALL EMPLOYEES CHECK-IN/CHECK-OUT REDUCER
		case NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_START:
			return { ...state, allEmployeesCheckInOut: null };
		case NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_SUCCESS:
			return {
				...state,
				allEmployeesCheckInOut: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_KEY,
				),
			};
		case NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_FAILURE:
			return {
				...state,
				allEmployeesCheckInOut: { status: 'error', message: action.payload },
			};
		// CHECK-IN LOCKED REDUCER
		case NewReportTypes.CHECK_IN_LOCKED_START:
			return { ...state, checkInLockedResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_SUCCESS:
			return {
				...state,
				checkInLockedResponse: decodeHexResponse(
					action.payload,
					NewReportTypes.CHECK_IN_LOCKED_KEY,
				),
			};
		case NewReportTypes.CHECK_IN_LOCKED_FAILURE:
			return {
				...state,
				checkInLockedResponse: { status: 'error', message: action.payload },
			};
		case NewReportTypes.CHECK_IN_LOCKED_RESPONSE_CHANGED:
			return { ...state, checkInLockedResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_RESPONSE_REST_START:
			return { ...state, checkInLockedResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_HISTORY_START:
			return { ...state, checkInLockedHistoryResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_HISTORY_SUCCESS:
			return {
				...state,
				checkInLockedHistoryResponse: decodeHexResponse(
					action.payload,
					NewReportTypes.CHECK_IN_LOCKED_HISTORY_KEY,
				),
			};
		case NewReportTypes.CHECK_IN_LOCKED_HISTORY_FAILURE:
			return {
				...state,
				checkInLockedHistoryResponse: { status: 'error', message: action.payload },
			};
		case NewReportTypes.CHECK_IN_LOCKED_HISTORY_RESPONSE_CHANGED:
			return { ...state, checkInLockedHistoryResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_HISTORY_RESPONSE_REST_START:
			return { ...state, checkInLockedHistoryResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_EXCUSE_START:
			return { ...state, checkInLockedExcuseResponse: null };
		case NewReportTypes.CHECK_IN_LOCKED_EXCUSE_SUCCESS:
			return {
				...state,
				checkInLockedExcuseResponse: decodeHexResponse(
					action.payload,
					NewReportTypes.CHECK_IN_LOCKED_EXCUSE_KEY,
				),
			};
		case NewReportTypes.CHECK_IN_LOCKED_EXCUSE_FAILURE:
			return {
				...state,
				checkInLockedExcuseResponse: { status: 'error', message: action.payload },
			};
		case NewReportTypes.CHECK_IN_LOCKED_EXCUSE_RESPONSE_CHANGED:
			return { ...state, checkInLockedExcuseResponse: null };
		case NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_START:
			return { ...state, checkInUnLockedHistoryResponse: null };
		case NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_SUCCESS:
			return {
				...state,
				checkInUnLockedHistoryResponse: decodeHexResponse(
					action.payload,
					NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_KEY,
				),
			};
		case NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_FAILURE:
			return {
				...state,
				checkInUnLockedHistoryResponse: { status: 'error', message: action.payload },
			};
		case NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED:
			return { ...state, checkInUnLockedHistoryResponse: null };
		case NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED_RESET:
			return {
				...state,
				checkInUnLockedHistoryResponse: null,
				checkInLockedExcuseResponse: null,
				checkInLockedHistoryResponse: null,
			};
		// FESTIVAL ADVANCE REPORT REDUCER
		case NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_START:
			return { ...state, festivalAdvanceReport: null };
		case NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_SUCCESS:
			return {
				...state,
				festivalAdvanceReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_FAILURE:
			return {
				...state,
				festivalAdvanceReport: { status: 'error', message: action.payload },
			};
		// GET ALL FESTIVAL NAMES REDUCER
		case NewReportTypes.GET_ALL_FESTIVAL_NAMES_START:
			return { ...state, allFestivalNames: null };
		case NewReportTypes.GET_ALL_FESTIVAL_NAMES_SUCCESS:
			return {
				...state,
				allFestivalNames: action.payload,
			};
		case NewReportTypes.GET_ALL_FESTIVAL_NAMES_FAILURE:
			return {
				...state,
				allFestivalNames: { status: 'error', message: action.payload },
			};
		// UPDATE FESTIVAL ADVANCE STATUS REDUCER
		case NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_START:
			return { ...state, updateFestivalAdvanceStatus: null };
		case NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_SUCCESS:
			// Check if response is encrypted (has response field) or plain
			if (action.payload?.response) {
				return {
					...state,
					updateFestivalAdvanceStatus: decodeHexResponse(
						action.payload,
						NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_KEY,
					),
				};
			} else {
				// Plain response (shouldn't happen for success, but handle it)
				return {
					...state,
					updateFestivalAdvanceStatus: action.payload,
				};
			}
		case NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_FAILURE:
			// Error responses are not encrypted, return as-is
			return {
				...state,
				updateFestivalAdvanceStatus: action.payload,
			};
		// MEDICAL ALLOWANCE REPORT REDUCER
		case NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_START:
			return { ...state, medicalAllowanceReport: null };
		case NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_SUCCESS:
			return {
				...state,
				medicalAllowanceReport: decodeHexResponse(
					action.payload,
					NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_KEY,
				),
			};
		case NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_FAILURE:
			return {
				...state,
				medicalAllowanceReport: { status: 'error', message: action.payload },
			};
		// UPDATE MEDICAL ALLOWANCE STATUS REDUCER
		case NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_START:
			return { ...state, updateMedicalAllowanceStatus: null };
		case NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_SUCCESS:
			// Check if response is encrypted (has response field) or plain
			if (action.payload?.response) {
				return {
					...state,
					updateMedicalAllowanceStatus: decodeHexResponse(
						action.payload,
						NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_KEY,
					),
				};
			} else {
				// Plain response (shouldn't happen for success, but handle it)
				return {
					...state,
					updateMedicalAllowanceStatus: action.payload,
				};
			}
		case NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_FAILURE:
			// Error responses are not encrypted, return as-is
			return {
				...state,
				updateMedicalAllowanceStatus: action.payload,
			};
		default:
			return state;
	}
};

export default newReportReducer;
